module.exports = __webpack_public_path__ + "feather.6335978d6e2344ee03de.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/feather/fonts/feather.svg?9xfrq8
// module id = ../../../../../src/assets/fonts/feather/fonts/feather.svg?9xfrq8
// module chunks = styles